import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onFilterToggle }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  const handleInputChange = (e) => {
    setSearchQuery(e?.target?.value);
  };

  const quickSearches = [
    { icon: 'Palette', label: 'Marketing help', query: 'marketing help' },
    { icon: 'Code', label: 'Tech support', query: 'technology support' },
    { icon: 'Heart', label: 'Animal rescue', query: 'animal rescue' },
    { icon: 'Calendar', label: 'Weekend events', query: 'weekend opportunities' }
  ];

  const handleQuickSearch = (query) => {
    setSearchQuery(query);
    onSearch(query);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <form onSubmit={handleSearch} className="flex gap-3">
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={onFilterToggle}
          className="lg:hidden flex-shrink-0"
          aria-label="Toggle filters"
        >
          <Icon name="SlidersHorizontal" size={20} />
        </Button>

        <div className="flex-1 relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
          </div>
          <Input
            type="search"
            placeholder="Try 'marketing help for animal rescue' or 'weekend opportunities near downtown'"
            value={searchQuery}
            onChange={handleInputChange}
            className="pl-10"
          />
        </div>

        <Button
          type="submit"
          variant="default"
          iconName="Search"
          iconPosition="left"
          className="hidden sm:flex"
        >
          Search
        </Button>
        <Button
          type="submit"
          variant="default"
          size="icon"
          className="sm:hidden flex-shrink-0"
          aria-label="Search"
        >
          <Icon name="Search" size={20} />
        </Button>
      </form>
      <div className="flex flex-wrap gap-2">
        <span className="text-sm text-muted-foreground flex items-center gap-2">
          <Icon name="Sparkles" size={16} />
          Quick searches:
        </span>
        {quickSearches?.map((item, index) => (
          <button
            key={index}
            onClick={() => handleQuickSearch(item?.query)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-muted hover:bg-primary/10 text-foreground hover:text-primary rounded-full text-sm font-medium transition-colors"
          >
            <Icon name={item?.icon} size={14} />
            {item?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;